import { Divider } from 'antd';

const Yimmugo = () => {
  return (
    <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md space-y-6">
      <Divider />
      <div className="space-y-2">
        <p>
          <b>What is YIMMUGO®? </b>
        </p>
        <p>
          YIMMUGO (immune globulin intravenous, human – dira) is an immune globulin (Ig) liquid used
          to treat primary humoral immunodeficiency in people 2 years of age and older.
        </p>
      </div>

      <div className="space-y-2 font-bold">
        <p>
          <b>IMPORTANT SAFETY INFORMATION </b>
        </p>
        <p>YIMMUGO may cause:</p>
        <ul className="list-disc list-inside pl-4 space-y-2">
          <li>
            Blood clots (thrombosis). Blood clots may occur in people taking Ig intravenous (IGIV)
            products, including YIMMUGO. You may be at greater risk for blood clots if you are
            older, sit or lie for long periods, have a clotting condition or a history of blood
            clots, take estrogen, have a central catheter, have thick blood, and/or if you have
            other conditions that put you at risk for cardiovascular disease. Blood clots may occur
            even if you do not have any of these risk factors. Your healthcare provider should
            monitor you for signs and symptoms of blood clotting.{' '}
          </li>
          <li>
            Impaired kidney function or kidney failure. IGIV products, particularly those that
            contain sugar (sucrose), have been associated with kidney dysfunction and damage, kidney
            failure, and death. Kidney damage and failure are more common in people receiving IGIV
            products containing sucrose. YIMMUGO does not contain sucrose. You may be at greater
            risk for kidney failure if you have kidney disease, diabetes, are seriously dehydrated,
            overweight, take drugs that may damage your kidneys, or are over age 65. Your healthcare
            provider should monitor your kidney function before and periodically after your first
            infusion.{' '}
          </li>
        </ul>
      </div>
      <div className="space-y-2">
        <p>
          <b>Do NOT use YIMMUGO if:</b>
        </p>
        <ul className="list-disc list-inside pl-4 space-y-2">
          <li>
            You have a history of severe hypersensitivity or a history of allergic reactions to
            human Ig. Tell your healthcare provider if you have had a serious reaction to other
            medicines that contain human Ig or ask if you are not sure.{' '}
          </li>
          <li>
            You have an immunoglobulin A (IgA) deficiency, have antibodies to IgA, or have a
            hypersensitivity or a history of allergic reactions. Tell your healthcare provider if
            you have an IgA deficiency or ask if you are not sure.{' '}
          </li>
        </ul>
      </div>
      <div className="space-y-2">
        <p>
          <b>WARNINGS AND PRECAUTIONS</b>
        </p>
        <ul className="list-disc list-inside pl-4 space-y-2">
          <li>
            Severe allergic reactions may occur. People with IgA deficiency who have antibodies
            against IgA may be at greater risk of these reactions.
          </li>
          <li>
            Blood damage called hemolysis and hemolytic anemia can develop after treatment with
            YIMMUGO. Your healthcare provider should monitor you for signs and symptoms.{' '}
          </li>
          <li>
            If you are at risk of developing kidney damage or failure, your healthcare provider
            should monitor your kidney function before and periodically after your first infusion.
          </li>
          <li>
            You could experience higher-than-normal levels of protein in your blood, thick blood, or
            low sodium (salt) in your blood. This may prevent your blood from flowing easily and
            possibly lead to blood clots.
          </li>
          <li>
            Brain swelling called aseptic meningitis syndrome may occur infrequently with IGIV
            products, especially if you receive a high dose or a rapid infusion.
          </li>
          <li>
            Swelling of the lungs may occur following treatment. Your healthcare provider should
            monitor you for signs of lung damage.{' '}
          </li>
          <li>
            YIMMUGO is made from human blood and may contain infectious agents, e.g., viruses and,
            theoretically, the Creutzfeldt-Jakob disease agent.
          </li>
          <li>
            Be sure to tell your healthcare provider about your recent history of vaccinations. Live
            vaccines for diseases like measles, mumps, rubella, and varicella may not work as well
            while receiving YIMMUGO. Tell your healthcare provider that you are taking YIMMUGO
            before you receive any vaccination.
          </li>
        </ul>
      </div>
      <div className="space-y-2">
        <p>
          <b>ADVERSE REACTIONS</b>
        </p>
        <p>
          The most common side effects of YIMMUGO were headache, upper respiratory tract infections,
          fatigue, nausea, and increased blood pressure. During treatment with YIMMUGO, be sure to
          tell your healthcare provider about any unusual symptoms you experience, as they may
          indicate a possible side effect.
        </p>
        <p>
          To report SUSPECTED ADVERSE REACTIONS, contact Kedrion Biopharma Inc. at 1-855-3KDRION
          (1-855-353-7466) or FDA at 1-800-FDA-1088 or{' '}
          <a href="www.fda.gov/medwatch" target="_blank" rel="noopener noreferrer">
            www.fda.gov/medwatch
          </a>
          .{' '}
        </p>
        <p>February 2025 YIM.0003.USA.25</p>
      </div>
    </div>
  );
};

export default Yimmugo;
